@if (maneuverForm) {
	<div [formGroup]="maneuverForm">
		<div class="ob-selection-section">
			@if (expensionShow) {
				<mat-accordion [multi]="true" class="ob-selection-accordion">
					@for (OB of TS1_OB_LIST; track OB.title; let i = $index) {
						@let cg = maneuverForm.get(OB.title);
						@if (cg) {
							<mat-expansion-panel
								class="fixed-maneuver"
								class="mat-elevation-z0"
								(opened)="panelOpenState = true"
								(closed)="panelOpenState = false"
								[expanded]="hasValue(OB.title)"
							>
								<mat-expansion-panel-header>
									<mat-panel-title>
										<div class="flex w-full flex-row items-center gap-2">
											<div class="size-2 rounded-full" [class.bg-red]="hasValue(OB.title)"></div>
											<span class="title whitespace-nowrap">
												<span class="font-bold">{{ OB.name }}</span>
												<span class="text-lg font-bold">&nbsp;&#183;&nbsp;</span>
												{{ OB.desc }}
											</span>
											<div class="mx-2 flex-1 border-b border-b-black"></div>
										</div>
									</mat-panel-title>
								</mat-expansion-panel-header>

								<div [formGroup]="$any(cg)">
									@if (
										this.formType == CONSTANT.FORM_TYPE.cabin_crew ||
										this.formType == CONSTANT.FORM_TYPE.cabin_crew_instructor
									) {
										<app-ob-container-single-selection
											[obFormGroup]="$any(cg)"
											[OB]="OB"
											[readOnly]="readOnly"
											(emitOBContainerValue)="onCheckBoxClick($event)"
										></app-ob-container-single-selection>
									} @else {
										<app-ob-container
											[obFormGroup]="$any(cg)"
											[OB]="OB"
											[readOnly]="readOnly"
											(emitOBContainerValue)="onCheckBoxClick($event)"
										></app-ob-container>
									}
								</div>
							</mat-expansion-panel>
						}
					}
				</mat-accordion>
			} @else {
				@for (OB of TS1_OB_LIST; track OB.title; let i = $index) {
					@let cg = maneuverForm.get(OB.title);

					@if (cg) {
						<div [formGroup]="$any(cg)">
							@if (
								this.formType == CONSTANT.FORM_TYPE.cabin_crew ||
								this.formType == CONSTANT.FORM_TYPE.cabin_crew_instructor
							) {
								<app-ob-container-single-selection
									[obFormGroup]="$any(cg)"
									[OB]="OB"
									[readOnly]="readOnly"
									(emitOBContainerValue)="onCheckBoxClick($event)"
								></app-ob-container-single-selection>
							} @else {
								<app-ob-container
									[obFormGroup]="$any(cg)"
									[OB]="OB"
									[readOnly]="readOnly"
									(emitOBContainerValue)="onCheckBoxClick($event)"
								></app-ob-container>
							}
						</div>
					}
				}
			}

			@if (isSafetyOutcomeVisible) {
				<div class="my-8">
					<app-cbta-checkbox-rating
						name="safetyOutcome"
						label="TEM Safety Outcome"
						(ratingChange)="onRatingChange($event)"
						[rating]="5"
						[currentValue]="$safeNavigationMigration(safetyOutcome?.value)"
						[isDisabled]="readOnly"
					></app-cbta-checkbox-rating>

					<input type="hidden" class="hidden" formControlName="safetyOutcome" [value]="safetyOutcome?.value ?? -2" />
				</div>
			}

			@if (isSafetyOutcomeVisible && !readOnly) {
				<div class="m-4 flex flex-row justify-between">
					<div class="grid grid-cols-3 gap-4">
						<button mat-stroked-button class="border !border-black !text-black" (click)="reaptConfirmModal()">
							Repeat
						</button>
					</div>
				</div>
			}
		</div>
	</div>
}
